import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { skillService } from '../../../services/skillService';

const SkillsShowcase = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const data = await skillService?.getAllSkills();
      setSkills(data || []);
    } catch (error) {
      console.error('Error fetching skills:', error);
      setSkills([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section className="py-12 md:py-16 lg:py-20 bg-background">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
            <p className="text-muted-foreground">Loading skills...</p>
          </div>
        </div>
      </section>
    );
  }

  if (skills?.length === 0) {
    return null;
  }

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12 lg:mb-16">
          <span className="inline-block px-4 py-2 bg-accent/10 text-accent rounded-full text-sm md:text-base font-medium mb-4">
            Expertise
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Skills & Technologies
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Comprehensive technical expertise across the full development stack
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {skills?.map((skill) => (
            <div
              key={skill?.id}
              className="group bg-card rounded-xl md:rounded-2xl p-6 md:p-8 border border-border hover:border-accent/50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-accent/10 rounded-lg md:rounded-xl flex items-center justify-center group-hover:bg-accent/20 transition-colors duration-300">
                  <Icon
                    name={skill?.icon}
                    size={24}
                    color="var(--color-accent)"
                    className="md:w-7 md:h-7 lg:w-8 lg:h-8"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2 group-hover:text-accent transition-colors duration-300">
                    {skill?.title}
                  </h3>
                </div>
              </div>

              <p className="text-sm md:text-base text-muted-foreground mb-4 leading-relaxed">
                {skill?.description}
              </p>

              <div className="flex flex-wrap gap-2">
                {skill?.technologies?.map((tech, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-muted text-muted-foreground text-xs md:text-sm rounded-full border border-border"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsShowcase;